import { ClipboardCheck } from 'lucide-react'

interface FormSubmissionProps {
  formData: any
}

export function FormSubmission({ formData }: FormSubmissionProps) {
  let parsedData = formData
  if (typeof formData === 'string') {
    try {
      parsedData = JSON.parse(formData)
    } catch (e) {
      parsedData = { raw: formData }
    }
  }

  const excludedFields = ['flow_token', 'flowToken', 'raw', 'rawResponse', 'screen', 'flowName']
  const formFields = Object.keys(parsedData).filter(key => !excludedFields.includes(key))

  return (
    <div
      className="max-w-xs"
      style={{ fontFamily: 'var(--wn-font)' }}
    >
      <div className="flex items-center gap-2.5 pb-2.5 border-b border-[#edf1f7]">
        <div
          className="h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: '#E8F8F0' }}
        >
          <ClipboardCheck className="h-4 w-4" style={{ color: '#1EB677' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div
            className="truncate"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}
          >
            Form Submitted
          </div>
          <div
            className="truncate mt-0.5"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
          >
            Information sent
          </div>
        </div>
      </div>
      <div className="mt-2.5 space-y-1.5">
        {formFields.map((field) => {
          const value = parsedData[field]
          if (value === null || value === undefined || value === '') return null

          const fieldLabel = field
            .replace(/_/g, ' ')
            .replace(/([A-Z])/g, ' $1')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ')

          return (
            <div
              key={field}
              className="flex items-baseline gap-1.5"
              style={{ fontFamily: 'var(--wn-font)', fontSize: 12 }}
            >
              <span style={{ color: '#6a7282', fontWeight: 600 }}>{fieldLabel}:</span>
              <span style={{ color: '#101828', fontWeight: 500, overflowWrap: 'anywhere' }}>
                {String(value)}
              </span>
            </div>
          )
        })}

        {formFields.length === 0 && parsedData.raw && (
          <div
            className="italic"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 12, fontWeight: 500, color: '#6a7282' }}
          >
            Form data received
          </div>
        )}
      </div>
    </div>
  )
}

